import actionConstants from '../constants/ActionConstants';

const initialState = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
};

const editSystemOrDevice = (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.EDIT_SYSTEM_OR_DEVICE_REQUEST:
      return {
        ...state,
        isFetching: true,
        isSuccess: false,
        isFailure: false,
        errorMessage: '',
      };
    case actionConstants.EDIT_SYSTEM_OR_DEVICE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isSuccess: true,
        isFailure: false,
        errorMessage: '',
      };
    case actionConstants.EDIT_SYSTEM_OR_DEVICE_FAILURE:
      return {
        ...state,
        isFetching: false,
        isSuccess: false,
        isFailure: true,
        errorMessage: action.message || 'Error editing system info',
      };
    case actionConstants.CLEAR_STATE:
      return initialState;
    default:
      return state;
  }
};

export default editSystemOrDevice;
